import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from "@material-ui/core/FormControl";
import {FormHelperText} from "@material-ui/core";

const FormCheckBox = (
  {
    input,
    label,
    meta,
    ...custom
  }) => {
  const showError = (meta.touched || meta.submitFailed) && Boolean(meta.error);

  return (
    <FormControl error={showError}>
      <FormControlLabel
        style={showError ? {color: "#f44336"} : undefined}
        control={
          <Checkbox
            {...custom}
            style={showError ? {color: "#f44336"} : undefined}
            checked={input.value}
            onChange={e => {
              input.onChange(e, !input.value);
            }}
            value={input.name}
          />
        }
        label={label}
      />
      {showError && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
}

FormCheckBox.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
};

export default FormCheckBox;
